import usePrivateAxios from "@/common/api/usePrivateAxios"
import { EstablishmentLeadsFunnelUpdateValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema"
import { useMutation } from "@tanstack/react-query"

interface UseUpdateEstablishmentLeadMasterUser {
  establishmentLeadId?: string,
  onSuccess?: () => void,
  onError?: () => void
}

export const useUpdateEstablishmentLeadMasterUser = ({ establishmentLeadId, onSuccess, onError }: UseUpdateEstablishmentLeadMasterUser) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updateEstablishmentLeadMasterUser'],
    mutationFn: async (data: EstablishmentLeadsFunnelUpdateValidationSchema) => {
      const lead = {
        contact_for_master_user_id: data.contact_for_master_user?.value
      }

      await privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
